/* Click/tap and native button keyboard behavior; no timer, hover flip or motion. */
if(!customElements.get('house-workpiece'))customElements.define('house-workpiece',class extends HTMLElement{
 connectedCallback(){
  if(this.ready)return;
  const button=this.querySelector('[data-workpiece-toggle]'),figure=this.closest('figure');
  if(!button||!figure)return;
  this.ready=true;
  const front=button.querySelector('[data-workpiece-front]'),back=button.querySelector('[data-workpiece-back]'),caption=figure.querySelector('[data-workpiece-caption]'),hint=figure.querySelector('[data-workpiece-hint]');
  button.addEventListener('click',()=>{
   const showBack=button.getAttribute('aria-pressed')!=='true';
   front.hidden=showBack;back.hidden=!showBack;
   button.setAttribute('aria-pressed',String(showBack));
   button.setAttribute('aria-label',showBack?button.dataset.frontLabel:button.dataset.backLabel);
   caption.textContent=showBack?caption.dataset.back:caption.dataset.front;
   hint.textContent=showBack?hint.dataset.frontHint:hint.dataset.backHint;
  });
 }
});
